import React, { useState } from 'react';

import { ReactComponent as MinusIcon } from '/src/images/icons/minus.svg';
import { ReactComponent as PlusIcon } from '/src/images/icons/plus.svg';

import { isBrowser } from '../../helpers/is-browser';
import { ILibraryMenuGroup } from '../../queries/fragments/libraryMenuGroup';
import LinkWrapper from '../ui/link-wrapper/link-wrapper';

interface SubMenuProps {
  menuGroup: ILibraryMenuGroup;
  id: string;
  isMobile: boolean;
}

export const FoldOutMenuSubMenu = ({
  menuGroup,
  id,
  isMobile,
}: SubMenuProps) => {
  const [open, setOpen] = useState<boolean>(false);

  const sendGtmEvent = (linkText: string) => {
    if (isBrowser && dataLayer) {
      dataLayer.push({
        event: 'menu_click',
        menu_item: linkText,
        menu_section: menuGroup.title,
      });
    }
  };
  return (
    <div>
      <button
        className="w-full pb-4 pt-3 text-left font-title text-headingm max-lg:flex max-lg:items-center max-lg:justify-between lg:pointer-events-none lg:pb-2.5"
        onClick={() => setOpen(!open)}
        aria-controls={`submenugroup-${id}`}
        aria-expanded={open}
      >
        <span>{menuGroup.title}</span>
        <span className="lg:hidden">
          {open && <MinusIcon />}
          {!open && <PlusIcon />}
        </span>
      </button>
      <ul
        className={`${open ? 'block' : 'hidden'} lg:block`}
        id={`submenugroup-${id}`}
        aria-hidden={isMobile && !open}
      >
        {menuGroup.pages?.map((page, index) => {
          const linkText =
            page.__typename === 'ContentfulLibraryExternalLink'
              ? page.linkTitle
              : page.name;
          return (
            (page.linkTitle || page.name) && (
              <li className="mb-4" key={`${page.slug}-${index}`}>
                <LinkWrapper
                  onClick={() => sendGtmEvent(linkText ?? '')}
                  data={page}
                  className="mb-3 block hover:text-text-light hover:underline"
                >
                  {linkText}
                </LinkWrapper>
              </li>
            )
          );
        })}
      </ul>
    </div>
  );
};
